import React, { useState, useEffect } from "react"
import { useDispatch, useSelector } from "react-redux";
import { Link, useHistory, useLocation } from "react-router-dom";
import { getAppeals } from "../feedback/actions";
import { ScreenSearch, Breadcrumbs, Table2, Empty } from "components";
import roleHOC from "HOC/roleHOC"
import TimeAgo from "javascript-time-ago";
import en from "javascript-time-ago/locale/en";
import { search } from "../../products/product";
import MobileProducts from "./mobile-products";

export const random = (min, max, round) => {
	let d = Math.floor(Math.random()*((max ? max : min)-min+1)+min);
	return round ? Math.round(d / 10)*10 : d;
};

import "./index.scss";
import useMobile from "../../../../../hooks/useMobile";
import MobilePlaceholder from "../../products/upselling/mobile-placeholder";


TimeAgo.addLocale(en)
const ReactTimeAgo = new TimeAgo("en-US")

const FILTERS = ["feedback_id", "out come", "reason"];
const Appeals = () => {

	const [loading, setLoading] = useState(true);
	const [appeals, setAppeals] = useState([]);
	const [searchKey, setSearch] = useState("");
	const dispatch = useDispatch();
	const history = useHistory();
	const isMobile = useMobile();
	const { state } = useLocation();
	const { profile } = useSelector(({auth}) => auth);
	const hasSubscription = profile && profile.subscription && profile.subscription.id

	useEffect(() => {
		if (!hasSubscription) {
			history.push('/feedback')
		}

		dispatch(getAppeals())
			.then(({data}) => {
				setLoading(true);
				setAppeals(data.appeals);
				if (state && state.search) {
					setSearch(state.search)
				}
			})
			.finally(() => {
				setLoading(false);
			})
	}, []);

	let renderReason = ({ row }) => <div className="badge badge-confirmation">{row.original.reason.toLowerCase().replaceAll("_", " ")}</div>
	let renderOutcome = ({ row }) => <div className={`badge badge-${row.original.outcome}`}>{row.original.outcome.toLowerCase().replaceAll("_", " ")}</div>
	let renderOutcomeDetails = ({ row }) => <div style={{ maxWidth: 300 }}>{row.original.outcome_details ? row.original.outcome_details : " - "}</div>;
	let renderFeedbackId = ({ row }) => <Link className="text-nowrap" to={`/feedback/reply/${row.original.feedback_id}`}>{row.original.feedback_id}</Link>;
	let renderTime = ({ row }) => ReactTimeAgo.format(row.original.created_at * 1000)

	const columns = [{
		accessor: 'feedback_id',
		Header: 'Feedback ID',
		Cell: renderFeedbackId,
	}, {
		accessor: 'reason',
		Header: 'Reason',
		Cell: renderReason,
	}, {
		accessor: 'outcome',
		Header: 'Outcome',
		Cell: renderOutcome,
	}, {
		accessor: 'outcome_details',
		Header: 'Details',
		width: "100px",
		Cell: renderOutcomeDetails,
	}, {
		accessor: 'updated_at',
		Header: 'Last Update',
		Cell: renderTime,
	}];

	const placeholder = [{
		accessor: "feedback_id",
		Header: "Feedback ID",
		Cell: () => <div className="skeleton skeleton1 text-nowrap" style={{ width: random(200)}}  />,
	}, {
		accessor: "reason",
		Header: "Reason",
		Cell: () => <div className="badge badge-paylixecommerce">Paylix</div>
	}, {
		accessor: "outcome",
		Header: "Outcome",
		Cell: () => <div className="badge badge-paylixecommerce">Paylix</div>
	}, {
		accessor: "outcome_details",
		Header: "Details",
		Cell: () => <div>
			<div className="skeleton skeleton2 small" style={{ marginBottom: ".5rem", width: random(400)}}  />
			<div className="skeleton skeleton2 small" style={{ marginBottom: ".5rem", width: random(400)}}  />
			<div className="skeleton skeleton2 small" style={{ marginBottom: ".5rem", width: random(200)}}  />
		</div>,
	}, {
		accessor: "updated_at",
		Header: "Last Update",
		Cell: () => <div className="skeleton skeleton1" style={{ width: random(150)}}  />,
	}];

	let data = searchKey ? search(appeals, FILTERS, searchKey) : appeals;

    if (!loading && !appeals.length) {
      return <Empty isAppeals />
    }

	return (
		<div className="appeals-screen">
			<div className="screen-header">
				<div className="d-flex flex-column">
					<Breadcrumbs title="Appeals" breadcrumbs={[{ title: 'Comms', link: '/' }, { title: 'Appeals', link: '/appeals' }]} />
				</div>

				<div className="screen-filters">
					<ScreenSearch className="long" onChange={setSearch} search={searchKey} />
				</div>
			</div>

			{isMobile ? null : loading ? <Table2 data={[1,2,3,4,5]} isPlaceholder columns={placeholder} /> : <Table2 data={data} columns={columns} />}
			{isMobile ? loading ? <MobilePlaceholder data={[1, 2, 3]} /> : <MobileProducts data={data} columns={columns} /> : null}
		</div>
	)
}


export default roleHOC(Appeals)
